/**
 * @generated SignedSource<<aecbb2a2fb7d4d0b370b72d42ff93673>>
 * @relayHash 7174e5f46f94e0340e2be57ace17cb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c4fb068086036b0d8869003abab5519d1e65fc7c47b58a70ea5c07745b05c8f

import type { ConcreteRequest } from 'relay-runtime';
export type useConnectorOnboardingStateQuery$variables = Record<PropertyKey, never>;
export type useConnectorOnboardingStateQuery$data = {
  readonly userPreferences: {
    readonly onboardingState: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null;
    }>;
  } | null;
};
export type useConnectorOnboardingStateQuery = {
  response: useConnectorOnboardingStateQuery$data;
  variables: useConnectorOnboardingStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "key",
            "value": [
              "twcg-1489:enrolmentDate",
              "twcg-1489:spotlightShown",
              "twcg-1489:promoDismissed"
            ]
          }
        ],
        "concreteType": "UserOnboardingState",
        "kind": "LinkedField",
        "name": "onboardingState",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ],
        "storageKey": "onboardingState(key:[\"twcg-1489:enrolmentDate\",\"twcg-1489:spotlightShown\",\"twcg-1489:promoDismissed\"])"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useConnectorOnboardingStateQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useConnectorOnboardingStateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7174e5f46f94e0340e2be57ace17cb1a",
    "id": "3c4fb068086036b0d8869003abab5519d1e65fc7c47b58a70ea5c07745b05c8f",
    "metadata": {},
    "name": "useConnectorOnboardingStateQuery",
    "operationKind": "query",
    "text": "query useConnectorOnboardingStateQuery{userPreferences{onboardingState(key:[\"twcg-1489:enrolmentDate\",\"twcg-1489:spotlightShown\",\"twcg-1489:promoDismissed\"]){key,value}}}"
  }
};
})();

(node as any).hash = "d9e97ff849d5b5284d9dd5284d3cab5d";

export default node;
